<script setup>
import { EditorContent } from '@tiptap/vue-2';
import { useAttrs, useListeners } from 'vue';

const props = defineProps({
  instance: {
    type: [Object],
    required: true,
  },
});

const attrs = useAttrs();
const listeners = useListeners();
</script>

<template>
  <EditorContent :editor="props.instance" v-bind="attrs" v-on="listeners" />
</template>
